import { render } from "./TextAreaDashboard.vue?vue&type=template&id=3fbee4ea&scoped=true"
import script from "./TextAreaDashboard.vue?vue&type=script&lang=js"
export * from "./TextAreaDashboard.vue?vue&type=script&lang=js"

import "./TextAreaDashboard.vue?vue&type=style&index=0&id=3fbee4ea&lang=scss&scoped=true"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbee4ea"]])

export default __exports__